import posthog from "posthog-js";

// Initialize PostHog
export const initPostHog = () => {
  const apiKey = process.env.REACT_APP_POSTHOG_API_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST;

  if (apiKey && host) {
    posthog.init(apiKey, {
      api_host: host,
      loaded: (posthog) => {
        if (process.env.NODE_ENV === "development") {
          // Add this line to see PostHog debug logs in development
          posthog.debug();
        }
      },
      capture_pageview: false, // We'll manually track pageviews
      capture_pageleave: true, // Capture when users leave your site
      autocapture: true, // Automatically capture clicks, form submissions etc.
    });
  }
};

// Export PostHog instance for direct usage
export { posthog };
